import { GetterTree } from 'vuex';
import { RootState } from '@/plugins/store';
import { EquipementInterventionsState } from '@/modules/Preventif/store/modules/state';

export const getters: GetterTree<EquipementInterventionsState, RootState> = {
    getEquipementInterventionsItems(state) {
        return state.interventions;
    },
    getAllEquipementInterventionsItems(state) {
        return state.interventionsNonPreventives;
    },
    getEquipementInterventionFilterDateFin(state): string {
        return state.filterDateFin;
    },
    getEquipementInterventionFilterDateDebut(state): string {
        return state.filterDateDebut;
    },
    getEquipementInterventionsIsLoading(state) {
        return state.isLoading;
    },
    getEquipementInterventionsPage(state) {
        return state.page;
    },
    getEquipementInterventionsNbOfPages(state) {
        return state.page;
    },
    getEquipementInterventionsScroll(state) {
        return state.scroll;
    },
    getEquipementInterventionsSort(state) {
        return state.sort;
    },
    getEquipementInterventionsCount(state) {
        return state.count;
    },
    getEquipementInterventionsTableHeader(state) {
        return state.tableHeader;
    },
    getEquipementInterventionsActive(state) {
        return state.active;
    },
    getEquipementInterventionsEquipementId(state) {
        return state.equipementId;
    },
};
